export default function (timeoutMs, reason = 'Timeout')
{
    const abortController = new AbortController();

    setTimeout(() => abortController.abort( reason ), timeoutMs || 0);

    return abortController.signal;
}
